(function() {
  'use strict';

  angular.module('app.parcels')
    .controller('ParcelsCtrl', ParcelsCtrl);

  /** @ngInject */
  function ParcelsCtrl($templateCache, $window, sessionService, $rootScope, $scope, $filter, $document, $state, $uibModal, maps, NgTableParams, Parcels, appConfig, tracts) {
    let vm = this;
    // console.log('vm.fields', vm.fields);
    let originalData = [];
    vm.featureType = 'Parcels';
    vm.bulkRow = {};
    vm.isCloseOut = false;
    let priorParcels = Parcels.getParcels();
    if (priorParcels.length > 0) {
      vm.parcels = priorParcels;
      // update fields coming from ArcGIS so they appear correctly and work correctly with the datatable and controls
      // for (let field in vm.fields) {
      //   if (vm.fields[field].type === 'esriFieldTypeDate') {
      //     _setupAllDates(vm.fields[field].name);
      //   }
      // }
    } else {
      vm.parcels = [];
    }

    // initial table loading is false
    vm.isLoading = false;

    // update loader when changing the parcel query from the workflow picker
    $scope.$on('reload-parcels', function() {
      vm.isLoading = true;
    });

    // add the close out button to the list when on the reconcile auction list step
    $scope.$on('close-tract-option', function(event, data) {
      vm.isCloseOut = data;
    });

    // bind the parcel list from the parcels factory
    $scope.$on('parcels-changed', function(event, newParcels) {
      // console.log('parcels-changed ', newParcels);
      // console.log('vm.fields ', vm.fields);
      vm.featureType = 'Parcels';
      vm.tableParams = {};
      vm.parcels = newParcels;

      for (let field in vm.fields) {
        if (vm.fields[field].type === 'esriFieldTypeDate') {
          _setupAllDates(vm.fields[field].name);
        }
      }

      originalData = angular.copy(vm.parcels);

      vm.tableParams = new NgTableParams({
        page: 1,
        count: 50
      }, {
        total: vm.parcels.length,
        dataset: vm.parcels
        // ,
        // getData: function(params) {
        //   let sorting = params.sorting();
        //   let key = sorting ? Object.keys(sorting)[0] : null;
        //   let reverse = sorting[key] === 'desc' ? true : false;
        //   let orderedData = sorting ? $filter('orderBy')(vm.parcels, key, reverse) : vm.parcels;
        //   vm.orderedData = orderedData;
        //   return (orderedData.slice((params.page() - 1) * params.count(), params.page() * params.count()));
        // }
      });
      vm.count = vm.parcels.length;
      vm.tableParams.reload();
      vm.isLoading = false;
    });

    // bind the tracts list from the parcels factory
    $scope.$on('tracts-changed', function(event, newParcels) {
      vm.featureType = 'Tracts';
      vm.tableParams = {};
      vm.parcels = newParcels;
      // console.log('Tracts Updated!');

      for (let field in vm.fields) {
        if (vm.fields[field].type === 'esriFieldTypeDate') {
          _setupAllDates(vm.fields[field].name);
        }
      }

      originalData = angular.copy(vm.parcels);

      vm.tableParams = new NgTableParams({
        page: 1,
        count: 50
      }, {
        total: vm.parcels.length,
        getData: function(params) {
          let sorting = params.sorting();
          let key = sorting ? Object.keys(sorting)[0] : null;
          let reverse = sorting[key] === 'desc' ? true : false;
          let orderedData = sorting ? $filter('orderBy')(vm.parcels, key, reverse) : vm.parcels;
          vm.orderedData = orderedData;
          return (orderedData.slice((params.page() - 1) * params.count(), params.page() * params.count()));
        }
      });
      console.log(vm.parcels);
      vm.count = vm.parcels.length;
      vm.tableParams.reload();
      vm.isLoading = false;
    });

    originalData = angular.copy(vm.parcels);

    // date format;
    vm.dateFormat = 'MM/dd/yyyy';

    // date picker open/closed forfeiture date
    vm.fStartDate = {
      date: null,
      open: false
    };

    vm.dateOptions = {
      //dateDisabled: disabled,
      formatYear: 'yyyy',
      maxDate: new Date(2020, 5, 22),
      minDate: new Date(),
      startingDay: 1
    };

    // open and close the forfeiture date pickers
    vm.fOpenStart = function(item) {
      item.open = true;
    };

    vm.fOpenEnd = function() {
      vm.fEndDate.open = true;
    };

    // open and close the forfeiture date pickers
    vm.fBulkStart = function() {
      vm.date.open = true;
    };

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 50
    }, {
      total: vm.parcels.length,
      getData: function(params) {
        let sorting = params.sorting();
        let key = sorting ? Object.keys(sorting)[0] : null;
        let reverse = sorting[key] === 'desc' ? true : false;
        let orderedData = sorting ? $filter('orderBy')(vm.parcels, key, reverse) : vm.parcels;
        vm.orderedData = orderedData;
        return (orderedData.slice((params.page() - 1) * params.count(), params.page() * params.count()));
      }
    });

    vm.count = vm.parcels.length;
    vm.cancel = cancel;
    vm.delConfirm = delConfirm;
    vm.save = save;
    vm.getDomainValues = getDomainValues;

    // watch for check all checkbox

    vm.checkboxes = {
      'checked': false,
      items: {}
    };

    $scope.$watch(angular.bind(vm, function() {
      return vm.checkboxes.checked;
    }), function(value) {
      angular.forEach(vm.orderedData, function(item) {
        if (item.attributes.Tract != null) {
          vm.checkboxes.items[item.attributes.Tract] = value;
        } else {
          vm.checkboxes.items[item.attributes.PIN] = value;
        }
      });
    });

    $scope.$watch(angular.bind(vm, function() {
      return vm.checkboxes.items;
    }), function() {
      if (!vm.parcels) {
        return;
      }
      var checked = 0,
        unchecked = 0,
        total = vm.parcels.length;
      angular.forEach(vm.parcels, function(item) {
        checked += (vm.checkboxes.items[item.attributes.Tract]) || 0;
        unchecked += (!vm.checkboxes.items[item.attributes.Tract]) || 0;
      });
      if ((unchecked === 0) || (checked === 0)) {
        vm.checkboxes.checked = (checked === total);
      }

      if (vm.parcels.length === 0) {
        vm.checkboxes.checked = false;
      }
      // grayed checkbox
      angular.element(document.getElementById('select_all')).prop('indeterminate', (checked !== 0 && unchecked !== 0));
    });

    vm.closeOutParcel = function(parcel) {
      console.log('close out: ', parcel);
      let modalInstance = $uibModal.open({
        animation: true,
        template: $templateCache.get('modules/core/modals/closeout.tpl.html'),
        controller: 'CloseOutCtrl',
        size: 'lg',
        resolve: {
          header: function() {
            return 'Close out Tract';
          },
          data: function() {
            return parcel;
          },
          fields: function() {
            return vm.fields;
          }
        }
      });

      modalInstance.result.then(function(closeOutData) {
        // steps to close out a tract after it sells
        // 1. Find all of the parcels that make up the tract
        // 2. Update the sold type and purchase date for all parcels in the tract
        parcel.attributes.PurchaseDate = closeOutData.PurchaseDate;
        parcel.attributes.Sold_type = closeOutData.Sold_type;
        parcel.attributes.TaxForfeitedStatus = closeOutData.TaxForfeitedStatus;
        parcel.attributes.Purch_price = closeOutData.PurchasedPrice;
        Parcels.updateParcelsInTract(parcel).then(function() {
          // 3. Archive the tract data in the historical table
          // 4. Delete the tract
          tracts.archiveAndDelete(parcel.attributes.Tract, closeOutData).then(function() {
            Parcels.list(false);
          });
        });
      }, function() {});
    };

    //////////

    function cancel(row, rowForm) {
      let originalRow = _resetRow(row, rowForm);
      angular.extend(row.attributes, originalRow.attributes);
    }

    function save(row, rowForm) {
      vm.saving = true;
      // alert('Changes saved');
      console.log('In parcels save function');
      Parcels.update(row).then(function() {
        // console.log(result);
        for (let field of vm.fields) {
          if (field.type === 'esriFieldTypeDate') {
            _setupDateField(field.name, row.attributes);
          }
        }
        let originalRow = _resetRow(row, rowForm);
        angular.extend(originalRow.attributes, row.attributes);
      });
      alert('Changes saved');
    }

    function getDomainValues(field) {
      return _.find(vm.fields, {
        'name': field
      }).domain.codedValues;
    }

    function delConfirm(row) {
      let modalInstance = $uibModal.open({
        animation: true,
        template: $templateCache.get('modules/core/modals/confirm.tpl.html'),
        controller: 'ConfirmDialogCtrl',
        size: 'sm',
        resolve: {
          message: function() {
            return 'Are you sure you want to delete this parcel?';
          },
          showWarning: function() {
            return false;
          }
        }
      });

      modalInstance.result.then(function() {
        // remove the parcel
        _delParcel(row);
      });
    }

    // HELPER FUNCTIONS***********************************************
    function _resetRow(row, rowForm) {
      row.isEditing = false;
      rowForm.$setPristine();
      vm.tableTracker.untrack(row);
      // changed _.findWhere (which was throwing an error) to _.find, per https://github.com/lodash/lodash/issues/172
      return _.find(originalData, function(r) {
        return r.attributes.GlobalID === row.attributes.GlobalID;
      });
    }

    function _delParcel(row) {
      Parcels.deleteParcel(row.attributes.OBJECTID).then(function() {
        const index = vm.tableParams.data.indexOf(row);
        vm.tableParams.data.splice(index, 1);
        $scope.$apply();
        vm.tableParams.reload().then(function(data) {
          if (data.length === 0 && vm.tableParams.total() > 0) {
            vm.tableParams.page(vm.tableParams.page() - 1);
            vm.tableParams.reload();
          }
        });
      });
    }

    function _setupAllDates(field) {
      for (let parcel of vm.parcels) {
        // if (field === 'Forfeiture_date') {
        //   console.log(parcel.attributes[field]);
        // }
        // if the date is already an object then don't set it
        if (parcel.attributes[field] == null) {
          parcel.attributes[field] = {
            date: null,
            open: false
          };
        } else if (typeof parcel.attributes[field] !== 'object') {
          if (parcel.attributes[field] != null) {
            let theDate = new Date(parcel.attributes[field]);
            parcel.attributes[field] = {
              date: new Date(theDate.getTime() + theDate.getTimezoneOffset() * 60000),
              open: false
            };
          }
        }
      }
    }

    function _setupDateField(field, row) {
      if (row[field] !== null) {
        let theDate = new Date(row[field]);
        row[field] = {
          date: theDate,
          open: false
        };
      }
    }

    // jshint ignore:start
    // function _formatDate(date) {
    //   return (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear();
    // }
    // jshint ignore:end
  }
})();
